
import { getSystemUpdate, delSystemUpgrade } from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import addNotice from "./components/add-notice.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-notice": addNotice
  }
})
export default class PiSIMManage extends Vue {
  private formInline: objAny = {
    globalPageIndex: 1,
    globalPageSize: 10,
    globalOrder: "",
    noticeStatus: "",
    noticeType: ""
  };

  private privilegeVoObj: objAny = {};
  private noticeStatusColor: objAny = {
    "1": "primary",
    "2": "default",
    "3": ""
  };
  private loading = false;
  private total = 0;

  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("systemNotice.upgradeContent"),
      key: "upgradeContent",
      minWidth: 300,
      ellipsis: true,
      tooltip: true
      // tooltipMaxWidth: 800
    },
    {
      title: i18n.t("systemNotice.upgradeTime"),
      key: "upgradeTime",
      minWidth: 100
    },

    {
      title: i18n.t("systemNotice.version"),
      key: "version",
      minWidth: 160
    },
    {
      title: i18n.t("operation"),
      key: "action",
      minWidth: 120,
      slot: "action"
    }
  ];
  public qyeryClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getSystemUpdate(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public addClick(): void {
    const addNotice: objAny = this.$refs["addNotice"];
    addNotice.open();
  }

  public editClick(item: objAny) {
    const addNotice: objAny = this.$refs["addNotice"];
    addNotice.open(item);
  }
  async delItemClick(item: objAny): Promise<void> {
    const ret = await delSystemUpgrade({
      pkId: item.pkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }

  mounted() {
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
    this.getTableList();
  }
}
